"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var pp_react_1 = require("@paypalcorp/pp-react");
var GetAddress = function (props) {
    var layout = props.displayMetadata;
    var textField = layout &&
        layout.map(function (item, index) { return (React.createElement(pp_react_1.Text, { id: item + index, className: props.className
                ? props.className + " addressBodyComponent"
                : "addressBodyComponent", size: "md" }, item)); });
    if (textField) {
        return textField;
    }
    else {
        return null;
    }
};
exports.default = GetAddress;
